import VisitsScreen from './VisitsScreen';

export default VisitsScreen;
